import { render, staticRenderFns } from "./badBelt.vue?vue&type=template&id=00c6d11b&scoped=true&"
import script from "./badBelt.vue?vue&type=script&lang=js&"
export * from "./badBelt.vue?vue&type=script&lang=js&"
import style0 from "./badBelt.vue?vue&type=style&index=0&id=00c6d11b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6d11b",
  null
  
)

export default component.exports